(function () {
  'use strict';

  function initScrollReveal(root) {
    var section = root || document.querySelector('.ee-bm[data-ee-bm-scroll-in="true"]');
    if (!section || section.dataset.eeBmObserved === 'true') {
      return;
    }
    if (!('IntersectionObserver' in window)) {
      section.classList.add('ee-bm--in-view');
      return;
    }
    section.dataset.eeBmObserved = 'true';
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            section.classList.add('ee-bm--in-view');
            io.disconnect();
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    io.observe(section);
  }

  function initMarquee(section) {
    if (!section || section.dataset.eeBmMarqueeReady === 'true') {
      return;
    }

    var track = section.querySelector('.ee-bm__track');
    var viewport = section.querySelector('.ee-bm__viewport');
    if (!track || !viewport) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    section.dataset.eeBmMarqueeReady = 'true';

    var firstSet = track.querySelector('.ee-bm__set');
    if (!firstSet) {
      return;
    }

    function resetClones() {
      var sets = track.querySelectorAll('.ee-bm__set');
      for (var i = sets.length - 1; i >= 2; i--) {
        track.removeChild(sets[i]);
      }
    }

    function ensureClones() {
      resetClones();
      var minWidth = Math.max(viewport.offsetWidth * 2, 1);
      var sets = track.querySelectorAll('.ee-bm__set');
      var guard = 0;

      while (track.scrollWidth < minWidth && sets.length < 12 && guard < 20) {
        var clone = firstSet.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        sets = track.querySelectorAll('.ee-bm__set');
        guard += 1;
      }
    }

    function updateShift() {
      var w = Math.round(firstSet.getBoundingClientRect().width);
      if (w > 0) {
        track.style.setProperty('--ee-bm-shift', '-' + w + 'px');
      }
    }

    function layout() {
      ensureClones();
      updateShift();
    }

    layout();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        layout();
      });
      ro.observe(viewport);
      ro.observe(firstSet);
    } else {
      window.addEventListener('resize', layout);
    }

    var imgs = firstSet.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', layout, { once: true });
      }
    });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('.ee-bm').forEach(function (section) {
      initMarquee(section);
      initScrollReveal(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
  });

  document.addEventListener('shopify:section:load', function (ev) {
    var section = ev.target && ev.target.querySelector && ev.target.querySelector('.ee-bm');
    if (section) {
      delete section.dataset.eeBmMarqueeReady;
      delete section.dataset.eeBmObserved;
      boot(ev.target);
    }
  });
})();
